import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props} aria-hidden="true">
            {/* <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0542831 20.4396C0.0200005 20.5268 0 20.6182 0 20.7139C0 20.8096 0.0200005 20.9025 0.0542831 20.9896C0.0900002 21.0754 0.142857 21.1539 0.208569 21.2196L13.7943 34.7911C14.0729 35.0696 14.5257 35.0696 14.8043 34.7911C15.0843 34.5125 15.0843 34.0596 14.8043 33.7811L2.43857 21.4282L39.2857 21.4282C39.68 21.4282 40 21.1096 40 20.7139C40 20.3196 39.68 19.9996 39.2857 19.9996L2.43857 19.9996L14.8043 7.64821C15.0843 7.36964 15.0843 6.91678 14.8043 6.63821C14.6657 6.49821 14.4829 6.42821 14.3 6.42821C14.1171 6.42821 13.9343 6.49821 13.7943 6.63821L0.208569 20.2082C0.142857 20.2739 0.0900002 20.3511 0.0542831 20.4396Z"
                fill="currentColor"
            /> */}
            <path
                d="M19.6309 38.9907C19.1196 38.9907 18.7012 38.5723 18.7012 38.0609V1.92978C18.7012 1.4184 19.1196 1 19.6309 1C20.1423 1 20.5607 1.4184 20.5607 1.92978V38.0609C20.5607 38.5723 20.1423 38.9907 19.6309 38.9907Z"
                fill="currentColor"
            />
            <path
                d="M19.6304 38.9907C19.398 38.9907 19.1562 38.8977 18.9796 38.7211C18.6169 38.3585 18.6076 37.7727 18.9796 37.4101L31.6989 24.5234C32.0615 24.1608 32.6473 24.1515 33.0099 24.5234C33.3725 24.886 33.3818 25.4718 33.0099 25.8344L20.2905 38.7211C20.1046 38.907 19.8721 39 19.6304 39V38.9907Z"
                fill="currentColor"
            />
            <path
                d="M19.649 38.9907C19.4072 38.9907 19.1655 38.8977 18.9888 38.7117L6.26946 25.825C5.90685 25.4624 5.91615 24.8673 6.26946 24.514C6.63207 24.1514 7.21783 24.1607 7.58045 24.514L20.2998 37.4007C20.6624 37.7634 20.6531 38.3584 20.2998 38.7117C20.1231 38.8884 19.8814 38.9814 19.649 38.9814V38.9907Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DownIcon
